<div class="flex items-center justify-center dialog-header ">
  {{ type }} Department
  <div class="absolute right-2">
    <button (click)="handleCloseDialog()" class="outline-none p-5">
      <i class="pi pi-times"></i>
    </button>
  </div>
</div>

<div class="dialog-content">
  <form [formGroup]="departmentForm" (ngSubmit)="submitForm()" class="p-fluid grid grid-cols-2 gap-6">

    <!-- Department Name -->
    <div class="flex flex-col">
      <label for="dept_name" class="mb-2 font-semibold">Department Name *</label>
      <input pInputText id="dept_name" formControlName="dept_name"
             class="w-full border rounded focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
      <div *ngIf="departmentForm.get('dept_name')?.invalid && (departmentForm.get('dept_name')?.touched || submitted)"
           class="text-red-500 text-xs mt-1">
        Department Name is required.
      </div>
    </div>

    <!-- Center ID -->
    <div class="flex flex-col">
      <label for="center_id" class="mb-2 font-semibold">Center ID *</label>
      <p-select id="center_id" formControlName="center_id"
                [options]="centers" optionLabel="center_name" optionValue="center_id"
                placeholder="Select a Center" class="w-full"></p-select>
                <div *ngIf="departmentForm.get('center_id')?.invalid && (departmentForm.get('center_id')?.touched || submitted)"
       class="text-red-500 text-xs mt-1">
    Center is required.
  </div>
                
    </div>

    <!-- Is Public -->
    <div class="flex flex-col">
      <label for="isPublic" class="mb-2 font-semibold">Is Public</label>
      <p-checkbox inputId="isPublic" binary="true" formControlName="isPublic"></p-checkbox>
    </div>

    <!-- Submit Button -->
    <div class="col-span-2 flex justify-end mt-6">
      <p-button label="Submit" type="submit" [loading]="isLoading" icon="pi pi-check" class="w-full"
                [disabled]="departmentForm.invalid || isLoading"></p-button>
    </div>

  </form>
</div>
